<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-8 col-xl-8">
                            <h3 class="nk-block-title page-title">Withdrawals</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Withdrawal.</p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" style="text-align:right;">
                            <a v-if="roleName=='Customer'" href="javascript:void(0)" v-on:click="openModel('Add')" class="btn btn-primary"><span>New Request</span></a>
                            <input v-else type="text" v-model="search" class="form-control" placeholder="Search..." />
                        </div>
                    </div>
                    
                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <table class="table table-orders">
                                    <thead class="tb-odr-head">
                                        <tr class="tb-odr-item">
                                            <th class="tb-odr-info">
                                                <span class="tb-odr-id">Code</span>
                                                <span class="tb-odr-id d-none d-md-inline-block" v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">User</span>
                                                <span class="tb-odr-id d-none d-md-inline-block" style="width: 160px;">Bank</span>
                                                <span class="tb-odr-date d-none d-md-inline-block">Date</span>
                                            </th>
                                            <th class="tb-odr-amount">
                                                <span class="tb-odr-total">Amount</span>
                                                <span class="tb-odr-status d-none d-md-inline-block">Status</span>
                                            </th>
                                            <th v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'" class="tb-odr-action" style="padding-left:0.5rem; padding-right:0.5rem;">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody class="tb-odr-body">
                                        <tr v-for="(details) in userList" v-bind:key="details.id" class="tb-odr-item">
                                            <td class="tb-odr-info">
                                                <span class="tb-odr-id"><a href="javascript:void(0)">{{details.code}}</a></span>
                                                <span class="tb-odr-id" v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">{{details.userName}}</span>
                                                <span class="tb-odr-id" style="width: 160px;">
                                                    {{details.bankName}} <br />
                                                    {{details.bankAccountNo}}
                                                </span>
                                                <span class="tb-odr-date">{{getDate(details.date)}}</span>
                                            </td>
                                            <td class="tb-odr-amount">
                                                <span class="tb-odr-total">
                                                    <span class="amount">${{AmountFormat(details.amount)}} <br /> <span v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">${{AmountFormat(details.feeAmount)}}</span> </span>
                                                </span>
                                                <span class="tb-odr-status">
                                                    <span v-if="details.approval==1" class="badge badge-dot bg-success">Approved</span>
                                                    <span v-if="details.approval==2" class="badge badge-dot bg-warning">Processing</span>
                                                    <span v-if="details.approval==3" class="badge badge-dot bg-danger">Rejected</span>
                                                </span>
                                            </td>
                                            <td class="tb-odr-action" style="padding-left:0.5rem; padding-right:0.5rem;" v-if="roleName=='Super Admin' || roleName=='Admin' || roleName=='Manager'">
                                                <div class="dropdown" v-if="details.approval==2">
                                                    <a class="text-soft dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                                                        <ul class="link-list-plain">
                                                            <li><a v-on:click="EditInfo(details, 'Approved', 'Edit')" href="javascript:void(0)">Approved</a></li>
                                                            <li><a v-on:click="EditInfo(details, 'Rejected', 'Edit')" href="javascript:void(0)">Rejected</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><!-- .card-inner -->
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <withdrawal-modal :userDetail="userDetail" :type="type" :approval="approval" :show="show" v-if="show" @close="IsSave" />
    </div>
</template>
<script>
    import moment from "moment";
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    export default {
        name: 'WithdrawalList',
        components: {
            Loading
        },
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: true,

                loading: false,
                show: false,
                userList: [],
                userDetail: '',
                roleName: '',
                type: '',
                approval: '',

            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {
            getDate: function (date) {
                return moment(date).format('D-MM-YYYY HH:mm');
            },

            IsSave: function () {
                this.show = false;
                this.getPage();
            },

            AmountFormat: function (amount) {
                return parseFloat(amount).toFixed(4);
            },

            AddSignup: function () {
                this.$router.push('/AddPackagePrice')
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },

            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Bonus/WithdrawalList?searchTerm=' + search + '&pageNumber=' + currentPage + '&isDesc=' + this.isDesc;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                        icon: 'error',
                        type: 'error',
                        title: 'Error',
                        text: "Something Went Wrong",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }).finally(() => root.loading = false);
            },


            openModel: function (type) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Bonus/WithdrawalNetAmountDetail?Id', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userDetail = response.data;
                        root.type = type;
                        root.show = true;
                    }
                });
            },

            EditInfo: function (detail, approval, type) {
                var root = this;

                root.userDetail = detail;
                root.approval = approval;
                root.type = type;
                root.show = true;
            },

        },
        created: function () {
        },
        mounted: function () {
            this.GetData(this.search, 1);

            this.roleName = localStorage.getItem('RoleName');
        },
    }
</script>